import { PatientWithAccessRightDTO } from '@peartherapeutics/weaver-api-client';
import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';

import { Config } from 'utils/config/config';
import { loadAuthToken, loadSessionId } from 'utils/tokenStorage';
import { routes } from 'utils/routeHelper';
import Program from 'utils/program';
import { clearCurrentPatient } from 'actions/currentPatient';

import ScrollToTop from 'components/common/ScrollToTop';

import './styles.scss';

interface IProps {
  currentPatient: Nullable<PatientWithAccessRightDTO>;
  clearCurrentPatient: () => void;
}

const Somryst = ({
  currentPatient,
  clearCurrentPatient: clearCurrentPatientProps,
}: IProps) => {
  const [loadedIframe, setLoadedIframe] = useState(false);
  const [iframe, setIframe] = useState(null);
  const iframeRef = useRef(null);

  const onIframeLoaded = () => {
    let iframeWindow: any;
    if (iframe === null) {
      // @ts-ignore
      iframeWindow = iframeRef.current.contentWindow;
      setIframe(iframeWindow);
      setLoadedIframe(true);
    }
  };

  const onPostMessageIframe = () => {
    const data = {
      authToken: loadAuthToken(),
      patientId: currentPatient!.id,
      sessionId: loadSessionId(),
    };
    // @ts-ignore
    iframe!.postMessage(data, Config.SOMRYST_WEB_URL);
  };

  useEffect(() => {
    if (currentPatient && loadedIframe) {
      onPostMessageIframe();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPatient, loadedIframe]);

  useEffect(() => {
    return () => {
      clearCurrentPatientProps();
      Program.clear();
    };
  }, [clearCurrentPatientProps]);

  if (!currentPatient) return <Redirect to={routes.PATIENT_SUMMARY} />;

  return (
    <div
      data-testid={!loadedIframe ? 'somryst' : 'somryst-loaded-iframe'}
      styleName="wrapper"
    >
      <ScrollToTop>
        {Config.SOMRYST_WEB_URL ? (
          <iframe
            ref={iframeRef}
            src={Config.SOMRYST_WEB_URL}
            title="somryst-iframe"
            onLoad={onIframeLoaded}
            styleName="iframe-wrapper"
          />
        ) : (
          <div>Please define SOMRYST_WEB_URL</div>
        )}
      </ScrollToTop>
    </div>
  );
};

const mapStateToProps = (state: IRootStateType) => ({
  currentPatient: state.currentPatient,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      clearCurrentPatient,
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(Somryst);
